
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.619 10.7l6.33-7.2h-1.5l-5.498 6.25L8.563 3.5H3.5l6.637 9.451L3.5 20.5H5l5.802-6.601 4.635 6.601H20.5M5.54 4.606h2.304l10.604 14.842h-2.304","fill":"currentColor"}})])
          )
        }
      }
    